/**
 * Variant Sale Toggle
 * ====================
 * Dynamically shows/hides the SALE badge and savings text
 * based on the selected variant's compare_at_price.
 *
 * Listens to both:
 * - 'variant:change' (legacy product-template system)
 * - 'variantChange' (within product section container)
 */
(function () {
  function toggleSaleElements(variant) {
    if (!variant) return;

    var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    // Toggle SALE badge
    var badges = document.querySelectorAll('[data-sale-badge]');
    badges.forEach(function (badge) {
      badge.style.display = hasSale ? '' : 'none';
    });

    // Toggle savings text
    var savingsTexts = document.querySelectorAll('[data-savings-text]');
    savingsTexts.forEach(function (el) {
      el.style.display = hasSale ? '' : 'none';
    });
  }

  // Listen to the global variant:change event (fired by both systems)
  document.addEventListener('variant:change', function (evt) {
    if (evt.detail && evt.detail.variant) {
      toggleSaleElements(evt.detail.variant);
    }
  });
})();
